import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'

import { DateMapper } from '../../components/common/dateMapper/DateMapper'
import LoadingSpinner from '../../components/common/spinner/LoadingSpinner'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'
import Icon from '../../components/common/icon/Icon'
import Tooltip from '../../components/common/tooltip/Tooltip'
import EmptyState from '../../components/common/emptyState/EmptyState'
import DataTable from '../../components/common/dataTable/DataTable'
import DataTableHeader from '../../components/common/dataTable/DataTableHeader'
import DataTableRow from '../../components/common/dataTable/DataTableRow'
import DataTableCol from '../../components/common/dataTable/DataTableCol'
import DataTableHeaderCol from '../../components/common/dataTable/DataTableHeaderCol'
import SingleLoader from '../../components/common/singleLoader/SingleLoader'
import Personalization from '../../components/common/personalization/Personalization'
import Pager from '../../components/common/pager/Pager'

import { getEmailMessages, getEmailSendings } from '../../api/beSendApi/BeSendApi'
import { getMessageDetails } from '../../api/beEmailMessageApi/BeEmailMessageApi'
import { getListDataById } from '../../api/beListApi/BeListApi'
import { getMessageTotalCounters, getMessageUrlTotalCounters } from '../../api/statisticsApi/StatisticsApi'

import { isSpecialLink, translateSpecialLink } from '../../services/SpecialLinks'

const PAGE_STATUS_READY = 'PAGE_STATUS_READY'
const PAGE_STATUS_ERROR = 'PAGE_STATUS_ERROR'
const PAGE_STATUS_PARAMS_ERROR = 'PAGE_STATUS_PARAMS_ERROR'
const PAGE_STATUS_LOADING = 'PAGE_STATUS_LOADING'

const initialPageState = {
  pageStatus: PAGE_STATUS_LOADING,
  loadData: true,
  statDeleted: undefined

}

const initialUrlList = {
  loadUrlList: false,
  emptyState: true,
  totalItems: null,
  pageSize: 10,
  pageNumber: 1,
  loading: true,
  error: false,
  data: []
}

let timeZoneCode = ''

// http://localhost:1234/frontend/linkreport/listGuid/AAFA5375-BCF1-4E06-965A-E3A98B626156/idList/1/idNL/90
// https://d4h1d.smtpnext.com/frontend/linkreport/listGuid/AAFA5375-BCF1-4E06-965A-E3A98B626156/idList/1/idNL/90

const LinkReport = ({ match, history, location, intl }) => {
  const [pageState, setPageState] = useState(initialPageState)
  const [msgData, setMsgData] = useState({})
  const [urlList, setUrlList] = useState(initialUrlList)
  const [listName, setListName] = useState('')

  function convertDateUtctoCTZ (dateString) {
    const dateInstance = new Date(dateString)
    // const tmp = new Date(dateInstance.getTime() + dateInstance.getTimezoneOffset() * 60000)
    // debugger
    return DateMapper.toLocalDate(dateInstance, timeZoneCode)
  }

  // on render
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  //  on mount
  useEffect(() => {
    reloadPage()

    // on unmount
    return () => { ReactTooltip.rebuild() }
  }, [])

  const listGuid = match.params.listGuid
  const idList = parseInt(match.params.idList)
  const idMessage = parseInt(match.params.idNL)

  useEffect(() => {
    if (pageState.loadData) {
      setPageState((prevState) => ({ ...prevState, loadData: false }))
      setUrlList((prevState) => ({ ...prevState, loadUrlList: true }))

      const search = {
        IdMessages: [idMessage],
        Completed: true
      }
      const types = ['EI']

      Promise.all([
        getEmailMessages(idList, listGuid, search, 1, 1, false),
        getListDataById(idList, listGuid)
      ]).then(([emailMessages, listData]) => {
        if (emailMessages.TotalItems > 0) {
          timeZoneCode = listData.TimeZoneCode
          setListName(listData.Name)
          setPageState((prevState) => ({ ...prevState, statDeleted: false }))
          Promise.all([
            getEmailSendings(idList, listGuid, search, 1, 1, false),
            getEmailSendings(idList, listGuid, search, 1, 1, true),
            getMessageDetails(idList, listGuid, idMessage, false),
            getMessageTotalCounters(idList, listGuid, idMessage, types, '', '')
          ]).then(([dateLastSendResp, dateFirstSendResp, msg, totalCounters]) => {
            setMsgData({
              Subject: msg.Subject,
              Notes: msg.Notes ? 'ID ' + idMessage + ' - ' + msg.Notes : 'ID ' + idMessage,
              DateLastSend: (dateLastSendResp && (dateLastSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs)) : '-',
              DateFirstSend: (dateFirstSendResp && (dateFirstSendResp.Items.length > 0)) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(dateFirstSendResp.Items[0].StartDateJs)) : '-',
              //   DateLastSendObj: (dateLastSendResp && (dateLastSendResp.Items.length > 0)) ? convertDateUtctoCTZ(dateLastSendResp.Items[0].StartDateJs) : null,
              //   DateFirsSendObj: (dateFirstSendResp && (dateFirstSendResp.Items.length > 0)) ? convertDateUtctoCTZ(dateFirstSendResp.Items[0].StartDateJs) : null
              Recipients: totalCounters.EI
            })

            setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY }))
          })
        } else {
          setPageState((prevState) => ({ ...prevState, statDeleted: true, pageStatus: PAGE_STATUS_READY }))
        }
      }).catch(() => {
        setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_ERROR }))
      })
    }
  }, [pageState.loadData])

  useEffect(() => {
    if (urlList.loadUrlList) {
      getMessageUrlTotalCounters(idList, listGuid, idMessage, urlList.pageSize, urlList.pageNumber, [])
        .then((res) => {
          console.log(res)
          setUrlList((prevState) => ({
            ...prevState,
            loading: false,
            error: false,
            totalItems: res.TotalItems,
            data: res.UrlCounters,
            emptyState: res.TotalItems === 0,
            loadUrlList: false
          }))
        })
        .catch(function () {
          setUrlList((prevState) => ({
            ...prevState,
            loading: false,
            error: false,
            loadUrlList: false
          }))
        })
    }
  }, [urlList.loadUrlList])

  const propStatDelted = {
    title: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsTitle' }),
    description: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsDescription' })
  }

  const personalizationProps = {
    idList: idList,
    showLogo: true,
    applyCustomCSS: true
  }

  const propsPager = {
    currentPage: urlList.pageNumber,
    itemsPerPage: urlList.pageSize,
    totalItems: urlList.totalItems,
    onChange: onChangePager,
    ofLabel: intl.formatMessage({ id: 'Load.Pager.Of' }),
    itemsLabel: intl.formatMessage({ id: 'Load.Pager.Items' })
  }

  function onChangePager (val) {
    setUrlList((prevState) => ({ ...prevState, pageNumber: val.pageNumber, pageSize: val.pageSize }))
  }

  function reloadPage () {
    setPageState((prevState) => ({ ...initialPageState, pageStatus: PAGE_STATUS_LOADING }))
  }

  function showURL (url, specialLinkType) {
    if (isSpecialLink(specialLinkType)) {
      return (<>{translateSpecialLink(intl, specialLinkType)}{' '}<em>(<FormattedMessage id='Load.Statistics.SpecialLink' />)</em></>)
    } else {
      return url
    }
  }

  return (
    <div className='frontend-wrapper-xl'>

      {(pageState.pageStatus === PAGE_STATUS_LOADING) &&
        <LoadingSpinner />}

      {(pageState.pageStatus === PAGE_STATUS_PARAMS_ERROR) &&
        <MessageFeedback kind='error'>{intl.formatMessage({ id: 'Load.Statistics.ErrorDisplayingReport' })}</MessageFeedback>}

      {(pageState.pageStatus === PAGE_STATUS_ERROR) &&
        <MessageFeedback kind='error'>
          {intl.formatMessage({ id: 'Load.Statistics.ErrorLoadingData' })}
          <a className='frontend-p-left-xs-thin test-OpenCLickReportPubb-reloadPage' onClick={reloadPage}>{intl.formatMessage({ id: 'Load.MailupCommon.ReloadData' })}</a>
        </MessageFeedback>}

      {pageState.statDeleted === true
        ? <>
          <Personalization {...personalizationProps} />
          <EmptyState {...propStatDelted} />
        </>
        : <>
          {(pageState.pageStatus === PAGE_STATUS_READY) && <>
            <Personalization {...personalizationProps} />
            <Tooltip />
            <div className='frontend-row frontend-row_reset row-flex'>
              <h1><b>{intl.formatMessage({ id: 'Load.Statistics.LinkReport' })}</b></h1>
            </div>

            <div className='frontend-row frontend-row_reset'>
              <div className='col-xs-8 frontend-p-left-0'>
                <div className='frontend-box frontend-p-bottom test-OpenCLickReportPubb-MsgDett'>
                  <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.MsgDett' })}</b></h3>
                  <p className='frontend-m-bottom-xx-sm'><strong>{msgData.Subject}</strong></p>
                  <p className='frontend-m-bottom-x-sm'>{msgData.Notes}</p>
                  <p className='frontend-m-bottom-x-sm'>
                    <b>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}:</b>&nbsp;
                    <span>{idList} - {listName}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.FirstSend' })}:</b>&nbsp;
                    <span>{msgData.DateFirstSend} {timeZoneCode.split(':')[0]}</span>
                  </p>
                  <p className='frontend-m-bottom-xx-sm'>
                    <b>{intl.formatMessage({ id: 'Load.Statistics.LastSend' })}:</b>&nbsp;
                    <span>{msgData.DateLastSend} {timeZoneCode.split(':')[0]}</span>
                  </p>

                </div>
              </div>
              <div className='col-xs-4 frontend-p-right-0'>
                <div className='frontend-box frontend-p-bottom test-OpenCLickReportPubb-Recipients'>
                  <h2><b>{intl.formatNumber(msgData.Recipients)}</b></h2>
                  <p className='frontend-text-uppercase frontend-note'>{intl.formatMessage({ id: 'Load.Statistics.SelectedRecipients' })}</p>
                </div>

              </div>
            </div>

            <div className='frontend-row frontend-m-bottom-double'>

              <div className='frontend-box frontend-m-bottom-0'>
                {urlList.loading ? <SingleLoader height='465px' />
                  : <>
                    {urlList.error ? <div className='m-bottom'>
                      <Icon family='fa' icon='exclamation-triangle' className='text-light' />&nbsp;
                      <span>{intl.formatMessage({ id: 'Load.Common.LoadDataError' })}</span>
                    </div> : <>
                                       {(urlList.emptyState)
                        ? <div className='text-center frontend-p-bottom frontend-p-top'>
                          <h3 className='text-center frontend-p-bottom-thin'>{intl.formatMessage({ id: 'Load.Statistics.EmptyStateSendLinkReportTitle' })}</h3>
                          <i className=''>{intl.formatMessage({ id: 'Load.Statistics.EmptyStateSendLinkReport' })}</i>
                        </div>
                        : <>

                                           <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.ListMsgUrl' })}</b></h3>
                                           <DataTable>
                            <DataTableHeader>

                              <DataTableHeaderCol width='10'>
                                {intl.formatMessage({ id: 'Load.Statistics.URL' })}
                              </DataTableHeaderCol>
                              <DataTableHeaderCol width='2' className='frontend-text-right'>
                                {intl.formatMessage({ id: 'Load.Common.TotalClicks' })}

                              </DataTableHeaderCol>

                            </DataTableHeader>
                            {urlList.data.map((item, index) =>
                              <DataTableRow key={index}>
                                {(item.Url || item.SpecialLinkType) ? <>
                                                   <DataTableCol width='10'>
                                    <p className='container_word-to-break'>{showURL(item.Url, item.SpecialLinkType)}</p>
                                  </DataTableCol>
                                                   <DataTableCol width='2' className='frontend-text-right'>
                                    <p>{intl.formatNumber(item.Counter)}</p>
                                  </DataTableCol>
                                                                                       </>
                                  : <DataTableCol width='12' className='frontend-text-right'>
                                    <Icon family='fa' icon='exclamation-triangle' className='text-light' />&nbsp;
                                    <span>{intl.formatMessage({ id: 'Load.Common.DataUnavailable' })}</span>
                                  </DataTableCol>}

                              </DataTableRow>
                            )}
                          </DataTable>
                                           <Pager {...propsPager} />
                                           </>}
                                              </>}
                  </>}
              </div>
            </div>

          </>}
          </>}

    </div>
  )
}

export default injectIntl(withRouter(LinkReport))
